import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';

// Components
import {
    ADMIN,
    ASSISTANT_MANAGER,
    MANAGER
} from 'components/RoleGate/constants';
import TimesheetTimesheetEntryForm from '../TimesheetTimesheetEntryForm';

interface OwnProps {
    onSubmit: (timesheetEntries: any) => void;
}

interface ConnectedProps {
    timesheetEntryModal?: boolean;
    defaultValues?: any;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class TimesheetTimesheetEntryModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            timesheetEntryModal: undefined,
            defaultValues: undefined
        });
    };

    render(): React.ReactElement {
        const { timesheetEntryModal, defaultValues, onSubmit } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={!!timesheetEntryModal}
                    onClose={this.handleClose}
                    size="fullscreen"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="TimesheetEntryModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <TimesheetTimesheetEntryForm
                            title="Create Entries"
                            onClose={this.handleClose}
                            defaultValues={defaultValues}
                            onSubmit={onSubmit}
                        />
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    timesheetEntryModal: makeSelectQueryStringValue('timesheetEntryModal'),
    defaultValues: makeSelectQueryStringValue('defaultValues')
});

export default connect(mapStateToProps, { updateQueryString })(
    TimesheetTimesheetEntryModal
);
